export default __webpack_public_path__ + "de89050f62cfb457a3a719c87030f64c.png";